module.exports = __webpack_public_path__ + "img/partner3.6dd86582.png";